// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__y5C1K","groupWrapper":"style_groupWrapper__9Pz84","dashboardTitle":"style_dashboardTitle__nFLX3"};